<template functional>
  <route v-bind="props" class="navbar-item">
    <slot></slot>
  </route>
</template>

<script>
export default {
  props: [ 'name', 'params', 'query', 'exact' ]
}
</script>
